export default __webpack_public_path__ + "static/Easons-Logo-287635876cb2313d28f1a6b7ef318be4.jpeg";